<div class="circle-progress">

  <img class="coins" src="/img/gold.png" alt="coins">

  <svg class="circle-progress-ring"
       [ngStyle]="{'top.px': innerCircleWidth - outerCircleWidth, 'left.px': innerCircleWidth - outerCircleWidth}"
       [attr.height]="(radius + innerCircleWidth + outerCircleWidth) * 2"
       [attr.width]="(radius + innerCircleWidth + outerCircleWidth) * 2">
    <circle class="progress-ring__circle" [(style.stroke-dashoffset)]="offset" [attr.stroke-dasharray]="dasharray"
            [attr.stroke-width]="outerCircleWidth" [attr.stroke]="progress == 100 ? '#00CC60' : '#92A0C0'" stroke="#11009E" fill="transparent"
            [attr.r]="radius + (innerCircleWidth + outerCircleWidth) / 2"
            [attr.cx]="radius + outerCircleWidth + innerCircleWidth"
            [attr.cy]="radius + outerCircleWidth + innerCircleWidth"/>
  </svg>

  <div class="circle-progress-text">
    <div class="circle-progress-text-progress">
      {{ progress }}<span class="percent">%</span>
    </div>
  </div>

</div>
